export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/add-cardetails-icon.5697048c.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};